// extracted by mini-css-extract-plugin
export var content = "_d2-3";
export var list = "_d2-4";
export var settingsContent = "_d2-7";
export var settingsPanel = "_d2-8";
export var state = "_d2-6";
export var triggerBadge = "_d2-2";
export var triggerButton = "_d2-1";
export var triggerShell = "_d2-0";
export var unreadDot = "_d2-5";